import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, MetricCard, EmptyState } from "@/components/lux";
import { money } from "@/lib/api";
import { Banknote } from "lucide-react";

export default function Salary() {
  const { data, loading } = useFetch("/user/salary");
  if (loading || !data) return <><PageTitle title="Activity IB Salary" /><div className="skeleton h-40" /></>;
  return (
    <div className="space-y-6">
      <PageTitle title="Activity IB Salary" subtitle="Performance salary for your current qualified slab" />
      <div className="grid gap-4 sm:grid-cols-3">
        <MetricCard label="Activity IB Salary" value={`$${money(data.salary_daily)}`} icon={Banknote} accent />
        <MetricCard label="Qualified Slab" value={data.salary_target ? `$${money(data.salary_target, 0)}` : "—"} icon={Banknote} />
        <MetricCard label="Total Activity IB Paid" value={`$${money(data.total_paid)}`} icon={Banknote} />
      </div>
      <div className="rounded-2xl p-6" style={{ background: "linear-gradient(160deg,#0f1613,#0a0f0c)", border: "1px solid rgba(34,197,94,0.3)", boxShadow: "0 16px 36px -14px rgba(0,0,0,0.55)" }}>
        <h3 className="mb-4 font-semibold" style={{ color: "#ffffff" }}>Activity IB Salary Ledger</h3>
        {data.ledger?.length ? (
          <div className="max-h-96 overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="text-left" style={{ color: "#ffffff" }}><tr className="border-b border-white/25"><th className="py-3 font-semibold">Date</th><th className="py-3 font-semibold">Slab</th><th className="py-3 text-right font-semibold">Amount</th></tr></thead>
              <tbody>
                {data.ledger.map((l, i) => (
                  <tr key={i} className="border-b border-white/10" style={{ color: "#ffffff" }}>
                    <td className="py-3">{l.date}</td><td className="py-3">${money(l.target, 0)}</td>
                    <td className="py-3 text-right font-bold">+${money(l.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2 py-10 text-center" data-testid="salary-empty">
            <div className="grid h-12 w-12 place-items-center rounded-full bg-black/30"><Banknote size={22} className="text-[var(--gold)]" /></div>
            <p className="text-base font-semibold" style={{ color: "#ffffff" }}>No salary credited yet</p>
            <p className="max-w-md text-sm" style={{ color: "rgba(255,255,255,0.85)" }}>Reach a business target to qualify for daily salary. Salary is not cumulative — the highest qualified slab applies.</p>
          </div>
        )}
      </div>
    </div>
  );
}
